// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

/** Seeded randomness for the logo: the same seed draws the same cloud. DOM-free. */

export type Rng = () => number;

/** mulberry32: a small, fast 32-bit generator; values in [0, 1). */
export function rng(seed: number): Rng {
  let s = seed | 0;
  return () => {
    s = (s + 0x6d2b79f5) | 0;
    let t = Math.imul(s ^ (s >>> 15), 1 | s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** A standard normal sample (Box–Muller). */
export function gauss(R: Rng): number {
  let u = 0;
  while (!u) u = R();
  return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * R());
}
